import { Weekday } from "rrule/dist/esm/weekday.js";
export const byWeekdaysToWeekdays = (byWeekdays) => {
    const weekdays = [];
    byWeekdays.forEach((byWeekday) => {
        if (typeof byWeekday === "string") {
            weekdays.push(Weekday.fromStr(byWeekday));
        }
        else if (typeof byWeekday === "number") {
            weekdays.push(new Weekday(byWeekday));
        }
        else {
            weekdays.push(byWeekday);
        }
    });
    return weekdays;
};
//# sourceMappingURL=rrule.js.map